import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../Auth/Authcontext";
import { FiArrowLeft } from "react-icons/fi";



const AdminLogin = () => {

  
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);


  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });



  

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // ✅ LOGIN API
      const res = await axios.post(
        "https://irc.zentelex.com/api/app-user-auth/login",
        formData
      );

      const { token, user } = res.data;

      // ✅ Save in context
      login(user, token);

      // ✅ Save in sessionStorage
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("user", JSON.stringify(user));
      sessionStorage.setItem("role", user.role);

      toast.success("Login successful");

      // ✅ STEP 1: GET CURRENT STEP + CRDNO + CDDNO
      const stepRes = await axios.get(
        "https://irc.zentelex.com/api/workflow/current-step",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { current_step, crdNo, cddNo, isCompleted } = stepRes.data;

      // ✅ CASE 1: COMPLETED → START NEW FLOW
      if (isCompleted === true) {
        sessionStorage.removeItem("crdNo");
        sessionStorage.removeItem("cddNo");
        sessionStorage.removeItem("orderprocess");
        sessionStorage.removeItem("deliveryorder");

        navigate("/dashboard");
        return;
      }

      // ✅ SAVE CRD DATA
      if (crdNo) {
        sessionStorage.setItem("crdNo", crdNo);

        const clientRes = await axios.get(
          `https://irc.zentelex.com/api/master-client/client/by-crd/${crdNo}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        sessionStorage.setItem(
          "orderprocess",
          JSON.stringify(clientRes.data.data)
        );
      }

      // ✅ SAVE CDD DATA
      if (cddNo) {
        sessionStorage.setItem("cddNo", cddNo);

        const clientRes = await axios.get(
          `https://irc.zentelex.com/api/delivery-order/by-cdd/${cddNo}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        sessionStorage.setItem(
          "deliveryorder",
          JSON.stringify(clientRes.data.data)
        );
      }

      // ================================
      // ✅ CRD ROUTES
      // ================================
      const redirectCRD = (step) => {
        switch (step) {
          case 1:
            navigate("/order-processing");
            break;
          case 2:
            navigate("/gateway-entry");
            break;
          case 3:
            navigate("/kata-slip-data");
            break;
          case 4:
            navigate("/commodity-received-document");
            break;
          default:
            navigate("/order-processing");
        }
      };

      // ================================
      // ✅ CDD ROUTES
      // ================================
      const redirectCDD = (step) => {
        switch (step) {
          case 1:
            navigate("/do-form");
            break;
          case 2:
            navigate("/outbound-gateway-entry");
            break;
          case 3:
            navigate("/outbound-kata-slip-data");
            break;
          case 4:
            navigate("/do-form-2");
            break;
          default:
            navigate("/do-form");
        }
      };

      // ================================
      // ✅ DECIDE WHICH FLOW TO RESUME
      // ================================
      if (cddNo) {
        redirectCDD(current_step);
      } else if (crdNo) {
        redirectCRD(current_step);
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <div
          className="card shadow-lg border-0"
          style={{ width: "28rem", borderRadius: "12px" }}
        >
          <div
            className="card-body rounded-4 p-4"
            style={{ backgroundColor: "#3075A6" }}
          >
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn btn-link d-flex align-items-center gap-2 p-0 mb-3"
              style={{
                color: "white",
                textDecoration: "none",
                fontSize: "14px",
              }}
            >
              <FiArrowLeft size={18} />
              Back
            </button>

            <h3 className="text-center mb-4 fw-bold" style={{ color: "white" }}>
              Admin Login
            </h3>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-semibold text-white">
                  Email Address
                </label>
                <input
                  type="email"
                  className="form-control py-2"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold text-white">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control py-2"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>

              <button
                type="submit"
                className="btn w-100 py-2 fw-semibold"
                style={{ backgroundColor: "#EC662C", color: "white" }}
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>
            </form>
          </div>
        </div>
      </div>

      <ToastContainer />
    </>
  );
};

export default AdminLogin;

